export default __webpack_public_path__ + "static/media/PPI-garden-bed-010.e3a0d208.jpg";